var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageMediaIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 1H14.4146C14.2087 0.417404 13.6531 0 13 0C12.3469 0 11.7913 0.417404 11.5854 1H0.5V2H11.5854C11.7913 2.5826 12.3469 3 13 3C13.6531 3 14.2087 2.5826 14.4146 2H15.5V1ZM4.41465 8H15.5V7H4.41465C4.20873 6.4174 3.65311 6 3 6C2.34689 6 1.79127 6.4174 1.58535 7H0.5V8H1.58535C1.79127 8.5826 2.34689 9 3 9C3.65311 9 4.20873 8.5826 4.41465 8ZM9.58535 14H0.5V13H9.58535C9.79127 12.4174 10.3469 12 11 12C11.6531 12 12.2087 12.4174 12.4146 13H15.5V14H12.4146C12.2087 14.5826 11.6531 15 11 15C10.3469 15 9.79127 14.5826 9.58535 14Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageMediaIco);
export default __webpack_public_path__ + "static/media/manage-media-ico.70d0c2ee5cba7e1a4d15df6b9bf37d14.svg";
export { ForwardRef as ReactComponent };